const ORB_TOP_LEFT = {
  background: 'radial-gradient(circle, #AD34FE 0%, transparent 65%)',
  filter: 'blur(80px)',
  opacity: 0.18,
};
const ORB_BOTTOM_RIGHT = {
  background: 'radial-gradient(circle, #7b1fd4 0%, transparent 65%)',
  filter: 'blur(100px)',
  opacity: 0.14,
};
const GRID_BG = {
  backgroundImage: `linear-gradient(rgba(173,52,254,0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(173,52,254,0.06) 1px, transparent 1px)`,
  backgroundSize: '72px 72px',
};

function AmbientOrbs() {
  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none absolute -top-48 -left-48 h-[700px] w-[700px] rounded-full"
        style={ORB_TOP_LEFT}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-64 -right-32 h-[800px] w-[800px] rounded-full"
        style={ORB_BOTTOM_RIGHT}
      />
    </>
  );
}

const DEFAULT_RIGHT = (
  <>
    {/* Badge */}
    <div className="relative z-20 flex justify-center w-full">
      <div
        className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium backdrop-blur-md"
        style={{
          color: '#fff',
          borderColor: 'rgba(173,52,254,0.3)',
          background: 'rgba(173,52,254,0.1)',
          boxShadow: '0 0 24px rgba(173,52,254,0.2)',
        }}
      >
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#AD34FE] opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-[#AD34FE]" />
        </span>
        Nova Plataforma Disponível
      </div>
    </div>

    {/* Heading + Subtitle */}
    <div className="relative z-20 flex w-full max-w-xl flex-col items-center text-center gap-6">
      <h2
        className="text-4xl font-bold tracking-tight xl:text-5xl"
        style={{ color: '#fff', textShadow: '0 4px 24px rgba(0,0,0,0.5)', lineHeight: 1.15 }}
      >
        Transforme Conversas em{' '}
        <span
          style={{
            background: 'linear-gradient(90deg, #AD34FE, #34ADFE)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          Conversões
        </span>
      </h2>
      <p className="max-w-md text-base leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)' }}>
        Ainda não tem um plano? Descubra o poder da automação inteligente com o Verboo. Crie,
        gerencie e escale seus fluxos de atendimento em uma única plataforma.
      </p>
    </div>

    {/* CTA Card */}
    <div className="relative z-20 w-full max-w-sm">
      <div
        className="group relative flex flex-col items-center gap-5 rounded-3xl p-8 transition-all duration-300 hover:scale-[1.02]"
        style={{
          background: 'rgba(26, 14, 36, 0.6)',
          border: '1px solid rgba(173, 52, 254, 0.2)',
          backdropFilter: 'blur(32px)',
          boxShadow: '0 32px 64px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.05) inset',
        }}
      >
        <div className="absolute -inset-0.5 -z-10 rounded-3xl bg-gradient-to-br from-[#AD34FE] to-[#7b1fd4] opacity-20 blur-xl transition-opacity duration-300 group-hover:opacity-40" />
        <h3 className="text-xl font-semibold" style={{ color: '#fff' }}>
          Desbloqueie o Potencial
        </h3>
        <p className="text-center text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>
          Conheça nossas soluções e escolha o plano perfeito para o seu negócio.
        </p>
        <a
          href="https://verboo.ai/#prices"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 flex h-12 w-full items-center justify-center gap-2 rounded-xl text-sm font-semibold transition-all duration-200 active:scale-[0.98]"
          style={{
            color: '#fff',
            background: 'linear-gradient(135deg, #AD34FE 0%, #7b1fd4 100%)',
            boxShadow: '0 0 32px rgba(173,52,254,0.4), 0 4px 16px rgba(0,0,0,0.3)',
          }}
        >
          Conhecer Planos
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </a>
      </div>
    </div>
  </>
);

export function AuthLayout({ children, rightContent }) {
  const hasCustomRight = Boolean(rightContent);
  return (
    <div
      className="relative min-h-screen overflow-hidden flex"
      style={{ background: '#0a0612' }}
    >
      {/* Left Side: Form */}
      <div className="relative z-10 flex w-full flex-col items-center justify-center p-6 lg:w-[45%] xl:w-[40%]">
        <AmbientOrbs />
        <div className="relative w-full max-w-sm">{children}</div>
      </div>

      {/* Right Side (hidden on mobile) */}
      <div
        className={`relative hidden lg:flex lg:w-[55%] xl:w-[60%] flex-col items-center py-16 px-12 xl:px-16 ${hasCustomRight ? 'justify-center overflow-y-auto' : 'justify-evenly'}`}
      >
        {/* Background panel */}
        <div className="absolute inset-0 overflow-hidden rounded-l-3xl border-l border-white/5 bg-[#120a19]">
          <div
            aria-hidden
            className="pointer-events-none absolute -top-48 -left-48 h-[700px] w-[700px] rounded-full"
            style={ORB_TOP_LEFT}
          />
          <div
            aria-hidden
            className="pointer-events-none absolute -bottom-64 -right-32 h-[800px] w-[800px] rounded-full"
            style={ORB_BOTTOM_RIGHT}
          />
          <div
            aria-hidden
            className="pointer-events-none absolute top-1/2 left-2/3 h-[300px] w-[300px] -translate-y-1/2 rounded-full"
            style={{
              background: 'radial-gradient(circle, #34ADFE 0%, transparent 70%)',
              filter: 'blur(60px)',
              opacity: 0.07,
            }}
          />
          <div aria-hidden className="pointer-events-none absolute inset-0" style={GRID_BG} />
        </div>

        {hasCustomRight ? (
          <div className="relative z-20 w-full max-w-md flex flex-col items-start">
            {rightContent}
          </div>
        ) : DEFAULT_RIGHT}
      </div>
    </div>
  );
}

export function AuthLayoutCentered({ children }) {
  return (
    <div
      className="relative min-h-screen overflow-hidden flex items-center justify-center p-6"
      style={{ background: '#0a0612' }}
    >
      <AmbientOrbs />
      <div className="relative z-10 w-full max-w-sm">{children}</div>
    </div>
  );
}
